<template>
    <AppLayout title="Proveedores" :contrast="true">
        <Toast />
        <Breadcrumb
            name="Proveedores"
            routeName="proveedores"
            :page="`Carga de tarifario para ${proveedor.nombre}`"
        />
        <div class="bg-white rounded-lg shadow p-5 m-2 lg:mx-4 lg:w-full">
            <div class="font-medium text-gray-600 text-lg mb-2">
                Carga de tarifario
            </div>
            <div class="p-2">
                <div class="text-gray-800 mb-4 p-4">
                    <p class="mb-2">
                        El archivo excel (xlsx, xls) debera poseer las
                        siguientes columnas para ser valido
                    </p>
                    <ul class="ml-4">
                        <li class="list-disc">servicio_id</li>
                        <li class="list-disc">unidad</li>
                        <li class="list-disc">cordon_origen_id (requerido)</li>
                        <li class="list-disc">cordon_destino_id (requerido)</li>
                        <li class="list-disc">max</li>
                        <li class="list-disc">precio</li>
                        <li class="list-disc">precio_basico</li>
                        <li class="list-disc">precio_devolucion</li>
                        <li class="list-disc">precio_cambio</li>
                        <li class="list-disc">proveedor</li>
                    </ul>
                </div>
                <div class="mt-2 mb-8">
                    <div class="flex flex-col md:align-start md:flex-row space-y-2 md:space-y-0 md:space-x-2">
                        <input
                            name="file"
                            type="file"
                            ref="inputFile"
                            @input="form.archivo = $event.target.files[0]"
                            accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                            class="block w-full md:max-w-sm text-sm text-gray-900 bg-gray-50 rounded-lg border border-gray-300 cursor-pointer dark:text-gray-400 focus:outline-none focus:border-transparent dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400"
                        />
                        <Button class="justify-center " @click="handleUpload">Cargar tarifario</Button>
                        <Button class="justify-center" variant="dismissive" @click="handleClear"
                            >Limpiar campo</Button
                        >
                    </div>
                </div>

                <DataTable
                    :value="tarifario === null ? null : [tarifario]"
                    dataKey="id"
                    responsiveLayout="scroll"
                    scrollHeight="400px"
                >
                    <template #empty>
                        <div class="text-gray-600">
                            No hay un tarifario registrado
                        </div>
                    </template>
                    <Column header="servicio_id" field="servicio_id" />
                    <Column
                        header="cordon_origen_id"
                        field="cordon_origen_id"
                    />
                    <Column
                        header="cordon_destino_id"
                        field="cordon_destino_id"
                    />
                    <Column header="max" field="max" />
                    <Column header="precio" field="precio" />
                    <Column header="precio_basico" field="precio_basico" />
                    <Column
                        header="precio_devolucion"
                        field="precio_devolucion"
                    />
                    <Column header="precio_cambio" field="precio_cambio" />
                </DataTable>

                <div class="flex flex-col mb-2 mt-4 space-y-2 md:space-y-0 justify-end md:flex-row md:justify-end text-center">
                    <Button class="w-full md:w-auto justify-center"
                        :disabled="tarifario === null ? true : false"
                        @click="handleDownload"
                    >
                        Descargar tarifario
                    </Button>
                    <TextButton
                        class="w-full md:w-auto justify-center"
                        variant="destructive"
                        :disabled="tarifario === null ? true : false"
                        @click="deleteDialog = true"
                    >
                        <div class="flex items-center  space-x-2">
                            <Icon size="15">
                                <Trash />
                            </Icon>
                            <span>Eliminar tarifario</span>
                        </div>
                    </TextButton>
                    <Link :href="'/proveedores/' + proveedor.id + '/edit'">
                        <Button
                        class="w-full md:w-auto justify-center"
                         variant="dismissive">Cancelar</Button>
                    </Link>
                </div>
            </div>
        </div>
        <Dialog
            v-model:visible="deleteDialog"
            :style="{ width: '450px' }"
            header="Confirmar"
            :modal="true"
        >
            <div class="flex items-center">
                <i
                    class="pi pi-exclamation-triangle mr-3"
                    style="font-size: 2rem"
                />
                <div v-if="proveedor.nombre">
                    ¿Seguro que deseas eliminar <br />
                    el tarifario de <b>{{ proveedor.nombre }}</b
                    >?
                </div>
            </div>
            <template #footer>
                <div class="flex justify-end">
                    <Button variant="dismissive" @click="deleteDialog = false">
                        Cancelar
                    </Button>
                    <Button
                        variant="destructive"
                        :loading="loading"
                        @click="handleDelete"
                    >
                        Eliminar tarifario
                    </Button>
                </div>
            </template>
        </Dialog>
    </AppLayout>
</template>

<script>
import AppLayout from "@/Layouts/AppLayout.vue";
import Breadcrumb from "@/shared/Breadcrumb.vue";
import FileUpload from "primevue/fileupload";
import { Trash } from "@vicons/fa";
import { Icon } from "@vicons/utils";
import Button from "@/shared/Button.vue";
import TextButton from "@/shared/TextButton.vue";
import { Link } from "@inertiajs/inertia-vue3";
import axios from "axios";
import { Inertia } from "@inertiajs/inertia";

export default {
    components: {
        AppLayout,
        Breadcrumb,
        FileUpload,
        Link,
        Button,
        TextButton,
        Icon,
        Trash,
    },
    props: {
        proveedor: Object,
        tarifario: Object,
    },
    data() {
        return {
            form: {
                archivo: null,
            },
            loading: false,
            deleteDialog: false,
        };
    },
    methods: {
        reloadProps() {
            Inertia.reload({
                only: ["tarifario"],
                onError: () =>
                    this.dispatchNotification({
                        severity: "error",
                        summary: "Ha ocurrido un error",
                        detail: "Intenta más tarde",
                        life: 3000,
                    }),
            });
        },
        handleUpload() {
            let formData = new FormData();
            if (this.form.archivo === null) {
                this.$toast.add({
                    severity: "error",
                    summary: "Debes seleccionar un archivo",
                    life: 3000,
                });
                return;
            }
            formData.append("file", this.form.archivo);

            let url = "/proveedores/" + this.proveedor.id + "/cargar-tarifario";
            let headers = {
                "Content-Type": "multipart/form-data",
            };
            axios
                .post(url, formData, headers)
                .then((res) => {
                    console.log(res.data);
                    if (res.data.success) {
                        this.reloadProps();
                        this.$toast.add({
                            severity: "success",
                            summary: "Listo",
                            detail: res.data.message,
                            life: 3000,
                        });
                    }
                })
                .catch((error) => console.log(error.message));
        },
        handleClear() {
            this.form.archivo = null;
            this.$refs.inputFile.value = null;
        },
        handleDownload() {
            this.loading = true;
            axios
                .get(
                    "/proveedores/" +
                        this.proveedor.id +
                        "/descargar-tarifario",
                    {
                        responseType: "blob",
                    }
                )
                .then((res) => {
                    if (res.data.success === false) {
                        this.$toast.add({
                            severity: "error",
                            summary: "Ha ocurrido un error",
                            detail: res.data.message,
                            life: 3000,
                        });
                        this.loading = false;
                        console.log('hello from error');
                        return;
                    } else {
                        let blob = new Blob([res.data], {
                            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
                        });
                        let downloadXls = document.createElement("a");
                        downloadXls.href = window.URL.createObjectURL(blob);
                        downloadXls.download = `tarifario_${this.proveedor.nombre}.xls`;
                        downloadXls.click();
                        this.loading = false;
                    }
                })
                .catch((err) => {
                    console.error(err);
                    this.$toast.add({
                        severity: "error",
                        summary: "Ha ocurrido un error",
                        detail: "Intenta más tarde",
                        life: 3000,
                    });
                    this.loading = false;
                });
        },
        handleDelete() {
            axios
                .post(
                    "/proveedores/" + this.proveedor.id + "/eliminar-tarifario"
                )
                .then((res) => {
                    this.deleteDialog = false;
                    this.reloadProps();
                    if (res.data.success === true) {
                        this.$toast.add({
                            severity: "success",
                            summary: "Listo",
                            detail: res.data.message,
                            life: 3000,
                        });
                    } else {
                        this.$toast.add({
                            severity: "success",
                            summary: "Ha ocurrido un error",
                            detail: res.data.message,
                            life: 3000,
                        });
                    }
                })
                .catch((err) => {
                    this.deleteDialog = false;
                    console.error(err.message);
                });
        },
    },
};
</script>
